import { createContext, useContext, useMemo, useState } from "react";

const SeoContext = createContext({
    pageSeo: null,
    setPageSeo: () => {},
});

export function SeoProvider({ children }) {
    const [pageSeo, setPageSeo] = useState(null);
    const value = useMemo(() => ({ pageSeo, setPageSeo }), [pageSeo]);
    return <SeoContext.Provider value={value}>{children}</SeoContext.Provider>;
}

export function useSeoContext() {
    return useContext(SeoContext);
}
